import { Table, Tag, Spin, PageHeader, Select, Tabs } from "antd";

import { relativeTimeThreshold } from "moment";
import React, { Component } from "react";

import Dialog from "../shared/dialog";



import "../shared/css/list-page.css";
import "../shared/css/headerpages.css";
import "../shared/css/table.css";
import { keys } from "lodash";

// Load the full build.
var _ = require('lodash');



export default class BoardsReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      language: this.props.lang,
      EmpListDatasource: [],
      SectorListDatasource: [],
      
    };
  }

  componentDidMount() {
    console.log("statequery", this.state.query);
    fetch(process.env.REACT_APP_API_URL + "/api/getBoardsReport", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
         confirmid: localStorage.getItem("EmpId"),
        //  confirmid: 516
      }),
    })
      .then((Response) => Response.json())
      .then((result) => {
        console.log("result board report api", result);
        result.forEach((element) => {
            this.state.EmpListDatasource = element.EmpList;
            this.state.SectorListDatasource = element.SectorList;
            this.state.results = element.EmpList;
          });

          this.setState({
            EmpListDatasource: this.state.EmpListDatasource,
            results: this.state.results,
            SectorListDatasource: this.state.SectorListDatasource,
          });

        console.log(
          "this.state.EmpListDatasource",
          this.state.EmpListDatasource
        );
        console.log(
          "this.state.SectorListDatasource",
          this.state.SectorListDatasource
        );

      });
  }






  
  renderTable() {


    const output = _.map(_.groupBy(this.state.EmpListDatasource, 'SectorNameTH'), function(obj, key){
      var temp = {};
      temp[key] = _.groupBy(obj, 'StepPoint')
      // console.log('obj', obj)
      // console.log('temp', temp)
      // console.log('key', key)
      // console.log('temp[key]', temp[key])

      return {sector: key, score: temp[key]};
     
    });
    console.log('output', output)

    var total = (_.groupBy(this.state.EmpListDatasource, 'StepPoint'))
    console.log('total', total[4])

    const right = this.state.EmpListDatasource.filter((e) => {
      return e.StepPoint !== null
    })

    console.log('right ', right)

    return (
      <div style={{ marginTop: 35 }}>

        <table id="table-example-1">
            {/* render table header */}
          <tr>
            <th rowspan="2"> <b> สังกัด / หน่วยงาน </b> </th>
            <th colspan="5"> <b> ระดับผลการปฎิบัติงาน </b> </th>
            <th rowspan="2"> <b> รวม (คน) </b> </th>
          </tr>
          <tr>
            <th> <b> 5 </b></th>
            <th> <b> 4 </b></th>
            <th> <b> 3 </b></th>
            <th> <b> 2 </b></th>
            <th> <b> 1 </b></th>
          </tr>
{/* end render table header */}

{/* render bo table */}



                {output.map((item) => (
                    <tr> 
                        <td>{ item.sector} </td>   
                        
          
                        {item.score[5] == undefined? <td> - </td> : <td> {item.score[5].length} </td>} 
                        {item.score[4] == undefined? <td> - </td> : <td> {item.score[4].length} </td>} 
                        {item.score[3] == undefined? <td> - </td> : <td> {item.score[3].length} </td>} 
                        {item.score[2] == undefined? <td> - </td> : <td> {item.score[2].length} </td>} 
                        {item.score[1] == undefined? <td> - </td> : <td> {item.score[1].length} </td>} 
                        <td> {
                          right.filter((e) => 
                          { return e.SectorNameTH == item.sector; }).length
                        } </td>

                       
                    
                    </tr>
                ))}


            
                <tr>
                  <td rowspan={2}> รวม  </td>
                    {total[5] == undefined? <td> - </td> : <td> {total[5].length} </td>} 
                    {total[4] == undefined? <td> - </td> : <td> {total[4].length} </td>}
                    {total[3] == undefined? <td> - </td> : <td> {total[3].length} </td>}
                    {total[2] == undefined? <td> - </td> : <td> {total[2].length} </td>}
                    {total[1] == undefined? <td> - </td> : <td> {total[1].length} </td>}
                  
                  <td> {right.length} </td>
                </tr>
          
           

                <tr>
                  {total[5] == undefined? <td> - </td> : <td> {((total[5].length * 100) / this.state.EmpListDatasource.length).toFixed(2)} % </td>} 
                  {total[4] == undefined? <td> - </td> : <td> {((total[4].length * 100) / this.state.EmpListDatasource.length).toFixed(2)} % </td>}
                  {total[3] == undefined? <td> - </td> : <td> {((total[3].length * 100) / this.state.EmpListDatasource.length).toFixed(2)} % </td>}
                  {total[2] == undefined? <td> - </td> : <td> {((total[2].length * 100) / this.state.EmpListDatasource.length).toFixed(2)} % </td>}
                  {total[1] == undefined? <td> - </td> : <td> {((total[1].length * 100) / this.state.EmpListDatasource.length).toFixed(2)} % </td>}
                  <td>  {((right.length * 100) / this.state.EmpListDatasource.length).toFixed(2) } % </td>
                </tr>

        </table>
      </div>
    );
  }

  render() {
    return (
      <div style={{ marginLeft: 15, marginRight: 15 }}>
        <h3 style={{ textAlign: "center"}}>
        รายงานพิจารณาระดับผลการปฏิบัติงานบุคลากร ประจำปีการศึกษา 2564 <br/>
        Summary of level of work performance for Academic Year 2021
        </h3>
        

        <h3 style={{ textAlign: "center"}}> ฝ่าย {localStorage.getItem("DepartmentTH")}</h3>

        {/* <h3>ฝ่าย กิจการพิเศษ </h3> */}
        <h3> บุคลากรที่มีสิทธิประเมินทั้งหมด {this.state.EmpListDatasource.length} คน 
        <br/>
        (Amount of people in the criteria to be considered)
        </h3>

        
  
          {this.renderTable()}

     

        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <div style={{ textAlign: "center", marginTop: 25 }}>
                    <p> ลงชื่อ _________________________________</p>
                    <p>
                      {"( " +
                        localStorage.getItem("TitleTH") +
                        " " +
                        localStorage.getItem("FirstNameTH") +
                        " " +
                        localStorage.getItem("LastNameTH") +
                        " )"}
                    </p> 
                     <p> ตำแหน่ง {localStorage.getItem("PositionNameTH")}</p>
                    {/* <p> ( รศ.ดร. เขตไท	ลังการ์พินธุ์ )</p>
                    <p> ตำแหน่ง ผู้ช่วยอธิการบดีฝ่ายกิจการพิเศษ/ผู้อำนวยการโครงการจัดตั้งศูนย์ศึกษาวิจัยด้านสิทธิมนุษยชน <br/> คณะนิติศาสตร์ มหาวิทยาลัยพายัพ</p> */}
                    <p> วันที่ _________________</p>
                  </div>
                </div>

      </div>
    );
  }
}
